import React from 'react'

import { Title, Alert, Close } from '@zendeskgarden/react-notifications'

import styled from 'styled-components'

const FloatingAlert = styled(Alert)`
  float: right;
  top: 5px;
  right: 5px;
  width: 500px;
`

// flash.type is success or error
const FlashNotification = ({ flash, removeFlash }) => {
  const type = flash && flash.type
  const message = flash && flash.message
  const closeable = flash && flash.closeable
  const isSuccess = type && type === 'success'
  const title = isSuccess ? 'Success!' : 'Error!'

  return (
    message ?
      <FloatingAlert type={type}>
        <Title>{title}</Title>
        <div dangerouslySetInnerHTML={{ __html: message }} />
        {closeable ? <Close onClick={() => removeFlash()} aria-label="Close Alert" /> : null}
      </FloatingAlert> :
      null
  )
}

export default FlashNotification
